module.exports = __webpack_public_path__ + "img/typescript.d5f8a729.png";